import "./CarouselCards.costomization.scss";

import React, { useEffect, useRef, useState } from "react";
import {
  faChevronCircleLeft,
  faChevronCircleRight,
} from "@fortawesome/free-solid-svg-icons";

import CardResult from "./CardResult";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Slider from "react-slick";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
  carouselCards: {
    width: "80%",
    position: "relative",
    left: "45px",
    display: "block",
    minWidth: "0",
    minHeight: "0",
    "@media only screen and (max-height: 450px), only screen and (max-width: 600px)":
      {
        left: "10%",
      },
  },

  arrow: {
    position: "absolute",
    display: "block",
    height: "20px",
    width: "20px",
    lineHeight: "0px",
    cursor: "pointer",
    background: "transparent",
    color: theme.primaryColor,
    top: "50%",
    fontSize: "1.5em",
    WebkitTransform: "translate(0, -50%)",
    msTransform: "translate(0, -50%)",
    transform: "translate(0, -50%)",
    padding: "0",
    border: "none",
    outline: "none",
    opacity: "0.75",
  },
  arrowDisabled: { opacity: "0.15" },
  prevArrow: { composes: "$arrow", left: "-35px" },
  nextArrow: { composes: "$arrow", right: "-35px" },
}));

const NextArrow = ({ onClick, className }) => {
  const styles = useStyles();
  return (
    <div
      className={`${styles.nextArrow} ${
        className.includes("slick-disabled") ? styles.arrowDisabled : ""
      }`}
    >
      <FontAwesomeIcon
        icon={faChevronCircleRight}
        aria-hidden={"true"}
        onClick={onClick}
      />
    </div>
  );
};

const PrevArrow = ({ onClick, className }) => {
  const styles = useStyles();
  return (
    <div
      className={`${styles.prevArrow} ${
        className.includes("slick-disabled") ? styles.arrowDisabled : ""
      }`}
    >
      <FontAwesomeIcon
        icon={faChevronCircleLeft}
        aria-hidden={"true"}
        onClick={onClick}
      />
    </div>
  );
};

export default ({
  className,
  items,
  onClickItem,
  sendEvent,
  onSuggestionClick,
  onMapClick,
  onHoverToggle,
  selectedResultIndex,
  hoveredResultIndex,
  mapMode,
}) => {
  const [dragging, setDragging] = useState(false);
  const sliderRef = useRef();
  const divRef = useRef();

  useEffect(() => {
    sliderRef.current.slickGoTo(selectedResultIndex);
  }, [selectedResultIndex]);

  useEffect(() => {
    const wheelHandler = (e) => {
      e.preventDefault();
      if (Math.abs(e.deltaY) < 15) {
        return;
      }
      if (e.deltaY > 0) {
        sliderRef.current.slickNext();
      } else {
        sliderRef.current.slickPrev();
      }
    };
    divRef.current.addEventListener("wheel", wheelHandler);
    const referenceToAvoidLeak = divRef.current;
    return () =>
      referenceToAvoidLeak.removeEventListener("wheel", wheelHandler);
  }, [divRef]);

  return (
    <div
      className={[useStyles().carouselCards, className].join(" ")}
      ref={divRef}
    >
      <Slider
        ref={sliderRef}
        dots={false}
        adaptiveHeight={true}
        infinite={false}
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        arrows={true}
        focusOnSelect={true}
        initialSlide={0}
        swipeToSlide={true}
        centerMode={mapMode && items.length > 1}
        nextArrow={<NextArrow />}
        prevArrow={<PrevArrow />}
        variableWidth={true}
        rows={1}
        className={"reactSlickWrapper center"}
        beforeChange={() => {
          setDragging(true);
        }}
        afterChange={(newIndex) => {
          setDragging(false);
          if (onClickItem) onClickItem(items[newIndex], newIndex);
        }}
      >
        {items.map((result, index) => (
          <CardResult
            key={`card-results-${index}`}
            shouldHover={index === hoveredResultIndex}
            isSelected={index === selectedResultIndex}
            result={result}
            sendEvent={sendEvent}
            blockClick={dragging}
            onSuggestionClick={onSuggestionClick}
            onMapClick={onMapClick}
            onHoverToggle={onHoverToggle ? onHoverToggle(index) : () => {}}
          />
        ))}
      </Slider>
    </div>
  );
};
